import { render } from "./CourseConfirm.vue?vue&type=template&id=231528e4"
import script from "./CourseConfirm.vue?vue&type=script&lang=js"
export * from "./CourseConfirm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__